import { collection, doc, onSnapshot, orderBy, query } from "firebase/firestore";

import { db } from "../../../../firebase/firebase";

import { Message } from "../../types/message";

export const subscribeToServiceMessages = (threadId: string, callback: (messages: Message[]) => void) => {
  const messagesCollection = collection(doc(db, "service_chats", threadId), "Messages");
  const q = query(messagesCollection, orderBy("createdAt", "asc"));

  const unsubscribe = onSnapshot(q, (snapshot) => {
    const messages = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    })) as Message[];
    callback(messages);
  });

  return unsubscribe;
};
